export default __webpack_public_path__ + "static/char-s-32-zh-Hant-8b8f4d51639f4eafdc7df4e5f1826e1f.png";